module.exports = __webpack_public_path__ + "img/GSP.c493c690.png";